import React from "react";
import { Link } from "react-router-dom";
import { Twitter } from "lucide-react";
import { ASSETS } from "@/lib/assets";
import { useSettings } from "@/hooks/useSettings";
import { useCommunityLinks, platformIcon } from "@/hooks/useCommunityLinks";

export default function Footer() {
  const { data } = useSettings();
  const xUrl = data?.xUrl || "https://x.com";
  const { data: links = [] } = useCommunityLinks();
  const tg = links.find((l) => l.platform === "telegram");
  return (
    <footer className="bg-black border-t-3 border-neon mt-24 relative grain">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img src={ASSETS.circleLogo} alt="$ROBBED" className="w-12 h-12 rounded-full border-2 border-neon" />
            <div>
              <div className="font-display font-900 text-cream text-xl">$ROBBED</div>
              <div className="font-mono text-neon text-xs uppercase tracking-widest">The People's Meme Coin</div>
            </div>
          </div>
          <p className="font-display text-cream text-2xl mt-6 leading-tight">THEY GOT RICH.<br /><span className="text-neon">WE GOT ROBBED.</span></p>
          <a href={xUrl} target="_blank" rel="noreferrer" className="btn-ghost mt-6 !py-2 !px-4 !text-xs inline-flex" data-testid="footer-x-link">
            <Twitter className="w-4 h-4" /> Follow on X
          </a>
          {data?.telegramLive && tg && (tg.url || "").trim() && (
            <a href={tg.url} target="_blank" rel="noreferrer" className="btn-ghost mt-6 sm:ml-2 !py-2 !px-4 !text-xs inline-flex !border-neon" data-testid="footer-telegram-link">
              {React.createElement(platformIcon("telegram"), { className: "w-4 h-4" })} Join Telegram
            </a>
          )}
        </div>

        <div>
          <h4 className="font-heading font-900 uppercase text-neon text-sm mb-3">Explore</h4>
          <ul className="space-y-2 font-mono text-sm text-cream/80">
            <li><Link to="/wall" className="hover:text-neon">Robbed Wall</Link></li>
            <li><Link to="/memes" className="hover:text-neon">Meme Generator</Link></li>
            <li><Link to="/battles" className="hover:text-neon">Meme Battles</Link></li>
            <li><Link to="/hall-of-fame" className="hover:text-neon">Hall of Fame</Link></li>
            <li><Link to="/leaderboard" className="hover:text-neon">Leaderboard</Link></li>
            <li><Link to="/tokenomics" className="hover:text-neon">Tokenomics</Link></li>
            <li><Link to="/roadmap" className="hover:text-neon" data-testid="footer-roadmap">Roadmap</Link></li>
            <li><Link to="/chains" className="hover:text-neon">Choose Your Chain</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-900 uppercase text-neon text-sm mb-3">Transparency</h4>
          <ul className="space-y-2 font-mono text-sm text-cream/80">
            <li><Link to="/vault" className="hover:text-neon">The Vault</Link></li>
            <li><Link to="/links" className="hover:text-neon" data-testid="footer-official-links">Official Links</Link></li>
            <li><Link to="/login" className="hover:text-neon">Join The Robbed</Link></li>
            <li><a href={xUrl} target="_blank" rel="noreferrer" className="hover:text-neon">X / Twitter</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t-3 border-black bg-ink px-4 sm:px-6 py-6">
        <p className="max-w-4xl mx-auto font-mono text-[11px] leading-relaxed text-dim">
          $ROBBED is an independent community meme project and is not affiliated with or endorsed by
          Robinhood, Robinhood Markets, Solana, or any financial institution. Cryptocurrency assets are
          volatile and may lose value. Nothing on this website constitutes financial advice.
        </p>
        <p className="max-w-4xl mx-auto font-mono text-[11px] text-dim mt-3">© {new Date().getFullYear()} THE ROBBED. No suits. No banks. Just memes.</p>
      </div>
    </footer>
  );
}
